import {setRecipientExitPage} from '~/CreateFabricGreetingCard/navigation/utils';
import {GiftCardButton} from '~/common/fabric/GiftCard/components/GiftCardButton/GiftCardButton';

const params = new URL(document.location.href)?.searchParams;
const configId = !!params?.get('product_config_id');

export const createSteps = {
  meta: {
    // Not a step - global settings for steps
    editing: false,
    creating: true,
    showBackButton: true,
    countSteps: true,
  },
  create: {
    id: 1,
    name: 'create',
    path: 'create',
    displayName: 'Customize',
    title: `Customize Your Card`,
    nextRoute: 'egift-card',
    previousRoute: null,
    saveOnLeave: true,
    nextButtonText: 'Next: eGift card (optional)',
    hideInWebView: false,
    trackingLabel: 'customize',
    customButton:
      configId &&
      ((onClick, attrs) => (
        <GiftCardButton onClick={onClick} text="Next: Edit eGift Card" desktopWide {...attrs} />
      )),
  },
  'egift-card': {
    id: 2,
    name: 'egift-card',
    path: 'egift-card',
    displayName: 'Add an eGift Card (optional)',
    title: `eGift Card`,
    nextRoute: 'recipients',
    previousRoute: 'customize',
    saveOnLeave: true,
    nextButtonText: 'Next: Add recipient(s)',
    hideInWebView: false,
    trackingLabel: 'optionalGift',
  },
  recipients: {
    id: 3,
    name: 'recipients',
    path: 'recipients',
    displayName: 'Add recipient(s)',
    title: `Enter Or Edit Your Event Details`,
    nextRoute: 'recipients-message',
    previousRoute: 'egift-card',
    saveOnLeave: false,
    nextButtonText: 'Next: Add message(s)',
    hideInWebView: false,
    trackingLabel: 'recipients',
    trackEGift: true,
  },
  'recipients-message': {
    id: 4,
    path: 'recipients-message',
    name: 'recipientsMessage',
    displayName: 'Add messages',
    title: "Select one or more gift options you'd like to include in your invitation",
    nextRoute: 'review', // TODO: change to preview
    previousRoute: 'recipients',
    saveOnLeave: true,
    preLeaveRouteFunction: setRecipientExitPage,
    hideInWebView: false,
    trackingLabel: 'message',
    trackEGift: true,
  },
  review: {
    id: 5,
    path: 'review',
    name: 'review',
    displayName: 'Review & send',
    title: 'Review & send',
    nextRoute: 'success',
    previousRoute: 'recipients-message',
    saveOnLeave: true,
    nextButtonText: 'Purchase & send',
    hideInWebView: true,
    trackingLabel: 'review',
    trackEGift: true,
  },
  success: {
    id: 6,
    path: 'success',
    name: 'success',
    displayName: 'Success',
    title: 'Success',
    previousRoute: 'review',
    showFooter: true,
    showMegaNav: true,
    trackingLabel: 'complete',
  },
  exit: {
    // Routes us to the source page
    id: -1,
    path: !document.referrer?.includes?.('login') && document.referrer ? document.referrer : '/',
    hideInWebView: true,
  },
};

createSteps.customize = {
  ...createSteps.create,
  name: 'customize',
  path: 'customize',
  displayName: 'Customize',
};

export const numSteps = 5;
